import type { JDSAvatarV2ProgressRingProps } from './generated';
import React from 'react';

export const withLogic =
  (
    Component: React.ComponentType<JDSAvatarV2ProgressRingProps>
  ): React.FC<JDSAvatarV2ProgressRingProps> =>
  (props: JDSAvatarV2ProgressRingProps) => {
    const progress = (items: JDSAvatarV2ProgressRingProps): number => {
      let percent = items.progress ?? 0;
      if (percent < 0) {
        percent = Math.abs(percent);
      }
      if (percent > 100) {
        percent = percent % 100;
      }
      return percent * (360 * 0.01);
    };

    return <Component {...props} progress={progress(props)} />;
  };
